import * as React from 'react';
import { Draggable } from 'react-managed-draggable';
export class RowSeparatorRenderer extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            deltaX: null
        };
        this.handleDragStart = (event, dragInformation) => {
            const deltaX = this.props.clamp(this.props.index, dragInformation.current.x - dragInformation.start.x);
            this.setState({ deltaX });
        };
        this.handleDragMove = (event, dragInformation) => {
            const deltaX = this.props.clamp(this.props.index, dragInformation.current.x - dragInformation.start.x);
            this.setState({ deltaX });
        };
        this.handleDragEnd = (event, dragInformation) => {
            this.setState({ deltaX: null });
            const deltaX = this.props.clamp(this.props.index, dragInformation.current.x - dragInformation.start.x);
            if (deltaX !== null) {
                this.props.onMove(this.props.index, deltaX);
            }
        };
    }
    render() {
        let left = 0;
        if (this.state.deltaX !== null) {
            left = this.state.deltaX;
        }
        return React.createElement(Draggable, { onDragStart: this.handleDragStart, onDragMove: this.handleDragMove, onDragEnd: this.handleDragEnd },
            React.createElement(this.props.floatyRenderers.rowSeparatorHandleRenderer, { offset: left }));
    }
}
//# sourceMappingURL=row-separator-renderer.js.map